import React from 'react';
// @ts-ignore
import styles from './HosGauge.module.scss'; // Make sure this file exists or provide a fallback/default style if missing

type Props = {
  pct: number;           // 0..1
  gapPct?: number;       // bottom gap percent
  radius?: number;       // default 16 (viewBox 40×40)
  thickness?: number;    // stroke width
  color?: string;        // ring color
  label?: string;
  center?: string;
};

export default function HosGauge({
  pct,
  gapPct = 20,
  radius = 24,
  thickness = 3,
  color = '#22c55e',
  label = 'DR',
  center = '--:--'
}: Props) {
  return (
    <svg
      className={styles.hosGauge}
      viewBox="0 0 60 60"
      width="60"
      height="60"
      style={
        {
          '--gapPct': gapPct,
          '--pct': Math.max(0, Math.min(1, pct)),
          '--thickness': thickness
        } as React.CSSProperties
      }
      role="img"
      aria-label={`Remaining ${center}`}
    >
      <circle className={`${styles.ring} ${styles.track}`} cx="30" cy="30" r={radius} pathLength={100} />
      <circle
        className={`${styles.ring} ${styles.arc}`}
        cx="30"
        cy="30"
        r={radius}
        pathLength={100}
        style={{ stroke: color }}
      />
      <text x="30" y="30" className={styles.time} textAnchor="middle" dominantBaseline="central">
        {center}
      </text>
      <text x="30" y="52" className={styles.label} textAnchor="middle">
        {label}
      </text>
    </svg>
  );
}
